import { render, staticRenderFns } from "./crmButton.vue?vue&type=template&id=6ee55dac&"
import script from "./crmButton.vue?vue&type=script&lang=js&"
export * from "./crmButton.vue?vue&type=script&lang=js&"
import style0 from "./crmButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports